import React from "react";
import Hero from "../components/Hero";
import SectionHeading from "../components/SectionHeading";
import ServiceCard from "../components/ServiceCard";
import { Link } from "react-router-dom";

const highlights = [
  "Designed around a real brand look instead of default text blocks",
  "Warm honey palette with depth, contrast, and softer premium styling",
  "Multiple pages and reusable components for a more real site structure",
];

export default function HomePage() {
  return (
    <>
      <Hero />
      {/*
      <section className="px-6 py-20">
        <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-[0.95fr_1.05fr]">
          <SectionHeading
            eyebrow="Why it feels better"
            title="More visual hierarchy, better spacing, and real personality."
            description="This version is built to feel more like an actual brand site: softer layers, stronger cards, more contrast, better section rhythm, and a premium-but-earthy look that fits Honey & Comb."
          />
          <div className="grid gap-4">
            {highlights.map((item) => (
              <div
                key={item}
                className="rounded-[1.75rem] border border-amber-100 bg-white px-6 py-5 shadow-soft"
              >
                <div className="flex items-start gap-4">
                  <div className="mt-1 grid h-8 w-8 place-items-center rounded-full bg-amber-100 text-amber-800">
                    ✓
                  </div>
                  <p className="text-base leading-7 text-slate-700">{item}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      <section className="pb-24">
        <div className="mx-auto grid max-w-6xl gap-8  bg-forest px-8 py-10 text-white shadow-glow md:grid-cols-[1fr_auto] md:items-center md:px-12">
          <div>
            <div className="text-sm uppercase tracking-[0.24em] text-amber-200">
              Ready for the next step
            </div>
            <h3 className="mt-3 text-3xl font-semibold md:text-4xl">
              Do you want beehives on your property? Do you want to "Sponsor"
              one of our hives?
            </h3>
            <p className="mt-4 max-w-2xl text-base leading-7 text-white/80">
              Use the contact page to ask about our management plans! In
              addition to helping the pollinators in our area, you will receive
              upwards of 25lbs of honey depending on hive performance.
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex rounded-full bg-white px-6 py-3 text-sm font-semibold text-forest transition hover:-translate-y-0.5"
          >
            Contact Cedar & Comb
          </Link>
        </div>
      </section>
    </>
  );
}
